import { createPayloadAction } from '../../../core/helpers'

import {
  SET_MENU_TITLE_EXPANDED_ROW_KEYS,
  SET_MENU_TITLE_FOR_IGNORED_DISH_TYPE,
  SET_MENU_TITLE_HIGHLIGHTED_ROW_KEY,
} from '../action-types'

export const setMenuTitleForIgnoredDishType = createPayloadAction(
  SET_MENU_TITLE_FOR_IGNORED_DISH_TYPE,
)

export const setMenuTitleExpandedRowKeys = createPayloadAction(
  SET_MENU_TITLE_EXPANDED_ROW_KEYS,
)

export const setMenuTitleHighlightedRowKey = createPayloadAction(
  SET_MENU_TITLE_HIGHLIGHTED_ROW_KEY,
)
